(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nh-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const codeButtons = document.querySelectorAll('.nh-announcement-bar__code--copy');
    const klaviyoButtons = document.querySelectorAll('.nh-announcement-bar__code--klaviyo[data-klaviyo-form-id]');
    const clickableBars = document.querySelectorAll(
      '.nh-announcement-bar[data-klaviyo-form-id], .nh-announcement-bar[data-bar-url]'
    );

    function openKlaviyoForm(formId) {
      if (!formId) {
        return;
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }

    function openBarUrl(bar) {
      const url = bar.dataset.barUrl;
      if (!url) {
        return;
      }
      if (bar.dataset.barUrlNewTab === 'true') {
        window.open(url, '_blank', 'noopener');
        return;
      }
      window.location.href = url;
    }
    codeButtons.forEach((button) => {
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        const code = this.dataset.code;
        const copiedText = this.dataset.copiedText || 'Kopiert!';
        const textSpan = this.querySelector('.nh-announcement-bar__code-text');
        const originalText = textSpan.textContent;
        navigator.clipboard
          .writeText(code)
          .then(() => {
            textSpan.textContent = copiedText;
            setTimeout(() => {
              textSpan.textContent = originalText;
            }, 2000);
          })
          .catch((err) => {
            console.error('Failed to copy:', err);
          });
      });
    });
    klaviyoButtons.forEach((button) => {
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        openKlaviyoForm(this.dataset.klaviyoFormId);
      });
    });

    clickableBars.forEach((bar) => {
      bar.addEventListener('click', function (event) {
        if (event.target.closest('a, button')) {
          return;
        }

        if (bar.dataset.barUrl) {
          openBarUrl(bar);
          return;
        }

        openKlaviyoForm(bar.dataset.klaviyoFormId);
      });

      bar.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();

        if (bar.dataset.barUrl) {
          openBarUrl(bar);
          return;
        }

        openKlaviyoForm(bar.dataset.klaviyoFormId);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-application-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DESKTOP = '(min-width: 769px)';

  function setup(scope) {
    var grids = (scope || document).querySelectorAll('[data-nh-application-grid]');

    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.dataset.nhApplicationGridInit === '1') return;
      grid.dataset.nhApplicationGridInit = '1';

      var isDown = false;
      var startX = 0;
      var startScroll = 0;

      function updateScrollable() {
        var scrollable =
          window.matchMedia(DESKTOP).matches && grid.scrollWidth - grid.clientWidth > 2;
        grid.classList.toggle('nh-application-grid-can-scroll', scrollable);
      }

      updateScrollable();
      window.addEventListener('resize', updateScrollable);

      grid.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        if (!grid.classList.contains('nh-application-grid-can-scroll')) return;
        isDown = true;
        startX = e.clientX;
        startScroll = grid.scrollLeft;
        grid.classList.add('is-dragging');
        try {
          grid.setPointerCapture(e.pointerId);
        } catch (err) {}
      });

      grid.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        grid.scrollLeft = startScroll - (e.clientX - startX);
      });

      function end(e) {
        if (!isDown) return;
        isDown = false;
        grid.classList.remove('is-dragging');
        try {
          grid.releasePointerCapture(e.pointerId);
        } catch (err) {}
      }

      grid.addEventListener('pointerup', end);
      grid.addEventListener('pointercancel', end);
      grid.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup(document);
    });
  } else {
    setup(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    setup(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.nhFpInit) return;
      root.dataset.nhFpInit = '1';

      var track = root.querySelector('[data-nh-fp-track]');
      if (!track) return;

      var bar = root.querySelector('[data-nh-fp-bar]');
      var fill = root.querySelector('[data-nh-fp-fill]');

      function maxScroll() {
        return track.scrollWidth - track.clientWidth;
      }

      function updateFill() {
        var max = maxScroll();
        var ratio = max > 0 ? track.scrollLeft / max : 0;
        if (fill) fill.style.width = Math.max(0, Math.min(1, ratio)) * 100 + '%';
        if (bar) bar.classList.toggle('is-hidden', max <= 1);
      }

      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;
      var activePointerId = null;

      track.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      track.addEventListener('pointerdown', function (event) {
        if (typeof event.button === 'number' && event.button !== 0) return;
        if (maxScroll() <= 1) return;
        isDown = true;
        moved = false;
        activePointerId = event.pointerId;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-grabbing');
      });

      window.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var dx = event.clientX - startX;
        if (!moved && Math.abs(dx) > 3) {
          moved = true;
          if (track.setPointerCapture && activePointerId !== null) {
            try {
              track.setPointerCapture(activePointerId);
            } catch (err) {
              console.error(err);
            }
          }
        }
        track.scrollLeft = startScroll - dx;
        updateFill();
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        activePointerId = null;
        track.classList.remove('is-grabbing');
      }

      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      track.addEventListener(
        'click',
        function (event) {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        },
        true
      );

      track.addEventListener('scroll', updateFill, { passive: true });

      if (bar) {
        var barDown = false;

        var scrub = function (clientX) {
          var rect = bar.getBoundingClientRect();
          if (rect.width <= 0) return;
          var ratio = (clientX - rect.left) / rect.width;
          ratio = Math.max(0, Math.min(1, ratio));
          track.scrollLeft = maxScroll() * ratio;
          updateFill();
        };

        bar.addEventListener('pointerdown', function (event) {
          barDown = true;
          scrub(event.clientX);
          event.preventDefault();
        });

        window.addEventListener('pointermove', function (event) {
          if (barDown) scrub(event.clientX);
        });

        window.addEventListener('pointerup', function () {
          barDown = false;
        });
      }

      var moreBtn = root.querySelector('[data-nh-fp-more-btn]');
      if (moreBtn) {
        var wrapper = root.querySelector('[data-nh-fp-more]');
        var items = Array.prototype.slice.call(track.querySelectorAll('.grid-product'));
        var step = parseInt(root.getAttribute('data-nh-fp-visible'), 10) || items.length;
        var shown = step;

        var applyVisibility = function () {
          items.forEach(function (item, index) {
            if (index < shown) {
              if (item.style.display === 'none') {
                item.style.display = '';
                item.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
                  img.loading = 'eager';
                });
                item.querySelectorAll('[data-aos]').forEach(function (el) {
                  el.classList.add('aos-init');
                  el.classList.add('aos-animate');
                });
                if (item.hasAttribute('data-aos')) {
                  item.classList.add('aos-init');
                  item.classList.add('aos-animate');
                }
              }
            } else {
              item.style.display = 'none';
            }
          });

          if (wrapper) wrapper.style.display = shown >= items.length ? 'none' : '';
          if (typeof AOS !== 'undefined') AOS.refresh();
          updateFill();
        };

        moreBtn.addEventListener('click', function (event) {
          event.preventDefault();
          shown = Math.min(shown + step, items.length);
          applyVisibility();
        });

        applyVisibility();
      }

      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(function () {
          updateFill();
        });
        observer.observe(track);
      }

      window.addEventListener('resize', updateFill);
      updateFill();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-nh-fp]');
      for (var i = 0; i < roots.length; i++) initSection(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-hotspots"] && !Shopify.designMode) return;
  try {
    
  class NhHotspots extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.triggers = Array.from(this.querySelectorAll('[data-hotspot-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-hotspot-panel]'));
      this.onDocumentClick = this.handleDocumentClick.bind(this);
      this.onKeyup = this.handleKeyup.bind(this);
      this.onBlockSelect = this.handleBlockSelect.bind(this);
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggle(trigger.dataset.hotspotTrigger);
        });
      });
      this.querySelectorAll('[data-hotspot-close]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.closeAll();
        });
      });
      document.addEventListener('click', this.onDocumentClick);
      window.addEventListener('keyup', this.onKeyup);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('keyup', this.onKeyup);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    toggle(id) {
      const panel = this.panels.find((item) => item.dataset.hotspotPanel === id);
      if (!panel) return;
      if (panel.classList.contains('is-active')) {
        this.closeAll();
        return;
      }
      this.open(id);
    }

    open(id) {
      this.closeAll();
      const panel = this.panels.find((item) => item.dataset.hotspotPanel === id);
      const trigger = this.triggers.find((item) => item.dataset.hotspotTrigger === id);
      if (!panel || !trigger) return;
      panel.hidden = false;
      requestAnimationFrame(() => {
        panel.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        this.updatePanelPosition(panel);
        if (panel.dataset.popupMode === 'modal') {
          document.documentElement.classList.add('modal-open');
          const dialog = panel.querySelector('.nh-hotspot-popup__dialog');
          if (dialog) dialog.focus();
        }
      });
    }

    closeAll() {
      this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      this.panels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.closest('[data-hotspot-item]')?.classList.remove('is-edge-left', 'is-edge-right');
        panel.hidden = true;
      });
      document.documentElement.classList.remove('modal-open');
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.closeAll();
      }
    }

    handleKeyup(event) {
      if (event.key === 'Escape') {
        this.closeAll();
      }
    }

    handleBlockSelect(event) {
      const blockId = event.detail && event.detail.blockId;
      if (!blockId) return;
      const trigger = this.triggers.find((item) => item.dataset.hotspotTrigger === blockId);
      if (trigger) {
        this.open(blockId);
      }
    }

    updatePanelPosition(panel) {
      if (panel.dataset.popupMode !== 'popover') return;
      const item = panel.closest('[data-hotspot-item]');
      if (!item) return;
      item.classList.remove('is-edge-left', 'is-edge-right');
      const rect = panel.getBoundingClientRect();
      if (rect.right > window.innerWidth - 12) {
        item.classList.add('is-edge-right');
      }
      if (rect.left < 12) {
        item.classList.add('is-edge-left');
      }
    }
  }

  if (!customElements.get('nh-hotspots')) {
    customElements.define('nh-hotspots', NhHotspots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-product-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  const scrollTabIntoView = (tab, strip) => {
    if (!tab || !strip || window.matchMedia('(min-width: 769px)').matches) return;

    const stripRect = strip.getBoundingClientRect();
    const tabRect = tab.getBoundingClientRect();

    if (tabRect.left < stripRect.left) {
      strip.scrollLeft -= stripRect.left - tabRect.left + 8;
    } else if (tabRect.right > stripRect.right) {
      strip.scrollLeft += tabRect.right - stripRect.right + 8;
    }
  };

  const initProductTabs = (root) => {
    const strip = root.querySelector('[data-nh-product-tabstrip]');
    const panels = root.querySelector('[data-nh-product-tabpanels]');
    if (!strip || !panels) return;

    for (const btn of panels.querySelectorAll('.nh-product-tabs__tab')) {
      strip.appendChild(btn);
    }

    if (strip.dataset.nhTabsBound === 'true') return;
    strip.dataset.nhTabsBound = 'true';

    strip.addEventListener('click', (evt) => {
      const tab = evt.target.closest('.nh-product-tabs__tab');
      if (!tab) return;

      window.requestAnimationFrame(() => {
        scrollTabIntoView(tab, strip);
      });
    });

    const openTab = strip.querySelector('.nh-product-tabs__tab.is-open');
    if (openTab) {
      scrollTabIntoView(openTab, strip);
    }
  };

  const initAll = (scope) => {
    const container = scope || document;
    for (const root of container.querySelectorAll('[data-nh-product-tabs]')) {
      initProductTabs(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (evt) => {
    initAll(evt.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-product-tile-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  const activeIndex = (track) => {
    const width = track.clientWidth;
    if (!width) return 0;
    return Math.round(track.scrollLeft / width);
  };

  const syncDots = (media) => {
    const track = media.querySelector('[data-nh-product-tile-list-track]');
    const dots = media.querySelectorAll('[data-nh-product-tile-list-dot]');
    if (!track || !dots.length) return;

    const index = Math.min(activeIndex(track), dots.length - 1);

    dots.forEach((dot, i) => {
      const isActive = i === index;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  };

  const initMedia = (media) => {
    if (media.dataset.nhProductTileListBound === 'true') return;
    media.dataset.nhProductTileListBound = 'true';

    const track = media.querySelector('[data-nh-product-tile-list-track]');
    if (!track) return;

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        syncDots(media);
        ticking = false;
      });
    });

    media.querySelectorAll('[data-nh-product-tile-list-dot]').forEach((dot, i) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });

    let dragging = false;
    let startX = 0;
    let startScroll = 0;
    let moved = 0;

    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      track.style.scrollSnapType = '';
      if (moved > 4) {
        track.scrollTo({ left: activeIndex(track) * track.clientWidth, behavior: 'smooth' });
      }
    };

    track.addEventListener('pointerdown', (evt) => {
      if (evt.pointerType === 'touch' || evt.button !== 0) return;
      dragging = true;
      moved = 0;
      startX = evt.clientX;
      startScroll = track.scrollLeft;
      track.style.scrollSnapType = 'none';
      track.classList.add('is-dragging');
      track.setPointerCapture(evt.pointerId);
    });

    track.addEventListener('pointermove', (evt) => {
      if (!dragging) return;
      const delta = evt.clientX - startX;
      moved = Math.abs(delta);
      track.scrollLeft = startScroll - delta;
      evt.preventDefault();
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', (evt) => {
      if (dragging) evt.preventDefault();
    });

    window.addEventListener('resize', () => {
      syncDots(media);
    });

    syncDots(media);
  };

  const initAll = (scope) => {
    const container = scope || document;
    container.querySelectorAll('[data-nh-product-tile-list-media]').forEach(initMedia);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (evt) => {
    initAll(evt.target);
  });

  document.addEventListener('shopify:block:select', (evt) => {
    initAll(evt.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-reviewslider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();

    class NhReviewSlider {
      #controller = new AbortController();
      #pointerId = null;
      #startX = 0;
      #startScroll = 0;
      #dragging = false;
      #moved = false;

      constructor(root) {
        this.root = root;
        this.track = root.querySelector('[data-nh-reviewslider-track]');

        if (!this.track) return;

        const signal = this.#controller.signal;

        this.track.addEventListener('click', this, { capture: true, signal });
        this.track.addEventListener('dragstart', this, { signal });

        for (const type of ['pointerdown', 'pointermove', 'pointerup', 'pointercancel']) {
          this.track.addEventListener(type, this, { signal });
        }

        this.#applyMobileStart();
        this.#applyDesktopCenter();
      }

      get ready() {
        return Boolean(this.track);
      }

      destroy() {
        this.#controller.abort();
      }

      handleEvent(event) {
        if (event.type === 'dragstart') event.preventDefault();
        if (event.type === 'click') this.#onClick(event);
        if (event.type === 'pointerdown') this.#onPointerDown(event);
        if (event.type === 'pointermove') this.#onPointerMove(event);
        if (event.type === 'pointerup' || event.type === 'pointercancel') this.#onPointerUp(event);
      }

      #applyMobileStart() {
        if (this.root.dataset.nhReviewsliderStartSecondMobile !== 'true') return;
        if (!window.matchMedia('(max-width: 767px)').matches) return;

        const slides = [...this.track.querySelectorAll('[data-nh-reviewslider-slide]')];

        if (slides.length < 2) return;

        const trackStyles = getComputedStyle(this.track);
        const paddingLeft = Number.parseFloat(trackStyles.paddingInlineStart) || Number.parseFloat(trackStyles.paddingLeft) || 0;
        const targetScroll = slides[1].offsetLeft - paddingLeft;

        this.track.scrollLeft = Math.max(0, targetScroll);
      }

      #applyDesktopCenter() {
        if (!window.matchMedia('(min-width: 768px)').matches) return;

        const slides = [...this.track.querySelectorAll('[data-nh-reviewslider-slide]')];

        if (slides.length === 0) return;

        this.revealSlide(slides[0]);
      }

      revealSlide(slide) {
        if (!slide || !this.track) return;

        const track = this.track;
        const trackStyles = getComputedStyle(track);
        const paddingLeft = Number.parseFloat(trackStyles.paddingInlineStart) || Number.parseFloat(trackStyles.paddingLeft) || 0;
        const slideLeft = slide.offsetLeft;
        const slideWidth = slide.offsetWidth;
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        let targetScroll = isMobile
          ? slideLeft - paddingLeft
          : slideLeft - (track.clientWidth - slideWidth) / 2;
        const maxScroll = track.scrollWidth - track.clientWidth;

        targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
        track.scrollTo({ left: targetScroll, behavior: 'smooth' });
      }

      #onClick(event) {
        if (!this.#moved) return;

        event.preventDefault();
        event.stopPropagation();
        this.#moved = false;
      }

      #onPointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        this.#pointerId = event.pointerId;
        this.#dragging = true;
        this.#moved = false;
        this.#startX = event.clientX;
        this.#startScroll = this.track.scrollLeft;
        this.track.dataset.nhReviewsliderDragging = 'true';
        this.track.setPointerCapture(event.pointerId);
      }

      #onPointerMove(event) {
        if (!this.#dragging || event.pointerId !== this.#pointerId) return;

        const distance = event.clientX - this.#startX;

        if (Math.abs(distance) > 4) this.#moved = true;

        this.track.scrollLeft = this.#startScroll - distance;
        event.preventDefault();
      }

      #onPointerUp(event) {
        if (!this.#dragging || event.pointerId !== this.#pointerId) return;

        this.#dragging = false;
        this.#pointerId = null;

        if (this.track.hasPointerCapture(event.pointerId)) {
          this.track.releasePointerCapture(event.pointerId);
        }

        delete this.track.dataset.nhReviewsliderDragging;
        this.#snapToNearest();
      }

      #snapToNearest() {
        const slides = [...this.track.querySelectorAll('[data-nh-reviewslider-slide]')];

        if (slides.length === 0) return;

        const trackRect = this.track.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;
        let closest = slides[0];
        let smallest = Infinity;

        for (const slide of slides) {
          const rect = slide.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);

          if (distance < smallest) {
            smallest = distance;
            closest = slide;
          }
        }

        this.revealSlide(closest);
      }
    }

    const create = (root) => {
      if (instances.has(root)) return;

      const slider = new NhReviewSlider(root);

      if (slider.ready) instances.set(root, slider);
    };

    const init = (scope) => {
      for (const root of (scope || document).querySelectorAll('[data-nh-reviewslider-slider]')) {
        create(root);
      }
    };

    const teardown = (scope) => {
      for (const [root, slider] of instances) {
        if (scope && !scope.contains(root)) continue;

        slider.destroy();
        instances.delete(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => teardown(event.target));

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('[data-nh-reviewslider-slider]');

      instances.get(root)?.revealSlide(event.target.closest('[data-nh-reviewslider-slide]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-text-and-products-manual"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const instances = new Map();

      class nhTapmSlider {
        #abortController = new AbortController();
        #trackController;
        #track;
        #realSlides = [];
        #cloneCount = 0;
        #pointerId;
        #mouseDragging = false;
        #dragStartX = 0;
        #dragStartScroll = 0;
        #suppressClick = false;
        #scrollIdleTimer;
        #resizeTimer;
        #clickTimer;

        constructor(slider) {
          this.slider = slider;
          this.controls = slider.querySelector('.nh-tapm__controls');
          this.dots = slider.querySelector('[data-nh-tapm-dots]');
          this.previousButton = slider.querySelector('[data-nh-tapm-prev]');
          this.nextButton = slider.querySelector('[data-nh-tapm-next]');

          this.#buildGridPages();

          if (!this.#syncTrack()) return;

          slider.addEventListener('click', this, {
            capture: true,
            signal: this.#abortController.signal
          });
          window.addEventListener('resize', this, { signal: this.#abortController.signal });
          this.#buildDots();
          this.#updateControls();
        }

        get ready() {
          return Boolean(this.#track) && this.#realSlides.length > 0;
        }

        handleEvent(event) {
          if (event.type === 'scroll') this.#onScroll();
          if (event.type === 'click') this.#onClick(event);
          if (event.type === 'resize') this.#onResize();
          if (event.type === 'dragstart') event.preventDefault();
          if (event.type === 'pointerdown') this.#onPointerDown(event);
          if (event.type === 'pointermove') this.#onPointerMove(event);
          if (event.type === 'pointerup' || event.type === 'pointercancel') this.#onPointerUp(event);
        }

        destroy() {
          this.#abortController.abort();
          this.#trackController?.abort();
          clearTimeout(this.#scrollIdleTimer);
          clearTimeout(this.#resizeTimer);
          clearTimeout(this.#clickTimer);
        }

        get #infiniteLoop() {
          return this.slider.dataset.nhTapmInfiniteLoop === 'true';
        }

        #buildGridPages() {
          const track = this.slider.querySelector('[data-nh-tapm-grid-page]');

          if (!track || track.querySelector('.nh-tapm__page')) return;

          const pageSize = Number(track.dataset.gridColumns) * Number(track.dataset.gridRows);

          if (!pageSize) return;

          const fragment = document.createDocumentFragment();
          const slides = [...track.children];

          for (let index = 0; index < slides.length; index += pageSize) {
            const page = document.createElement('div');
            page.className = 'nh-tapm__page';
            page.append(...slides.slice(index, index + pageSize));
            fragment.append(page);
          }

          track.replaceChildren(fragment);
        }

        #syncTrack() {
          const tracks = [...this.slider.querySelectorAll('[data-nh-tapm-track]')];
          const activeTrack = tracks.find((track) => track.offsetParent !== null) || tracks[0];

          if (!activeTrack) return false;
          if (this.#track === activeTrack) return this.#realSlides.length > 0;

          this.#trackController?.abort();
          this.#trackController = new AbortController();
          this.#track = activeTrack;

          const signal = this.#trackController.signal;

          activeTrack.addEventListener('scroll', this, { passive: true, signal });
          activeTrack.addEventListener('dragstart', this, { signal });

          for (const type of ['pointerdown', 'pointermove', 'pointerup', 'pointercancel']) {
            activeTrack.addEventListener(type, this, { signal });
          }

          this.#setupSlides();

          return this.#realSlides.length > 0;
        }

        #setupSlides() {
          for (const clone of this.#track.querySelectorAll('[data-nh-tapm-clone]')) {
            clone.remove();
          }

          this.#cloneCount = 0;
          this.#realSlides = [...this.#track.children];

          const visibleCount = this.#getVisibleCount();

          if (!this.#infiniteLoop || this.#realSlides.length <= visibleCount) return;

          const cloneCount = Math.min(this.#realSlides.length, Math.max(6, visibleCount + 2));
          const makeClone = (slide) => {
            const clone = slide.cloneNode(true);
            clone.dataset.nhTapmClone = 'true';
            return clone;
          };

          this.#track.prepend(...this.#realSlides.slice(-cloneCount).map(makeClone));
          this.#track.append(...this.#realSlides.slice(0, cloneCount).map(makeClone));
          this.#cloneCount = cloneCount;
          this.#scrollToIndex(0, false);
        }

        #getStride() {
          const [first, second] = this.#track.children;

          if (first && second) return second.offsetLeft - first.offsetLeft;

          return first?.offsetWidth || 0;
        }

        #getVisibleCount() {
          if (this.#track.hasAttribute('data-nh-tapm-grid-page')) return 1;

          if (window.innerWidth <= 768) {
            return Number(this.slider.dataset.mobileVisibleColumns) || 1;
          }

          const stride = this.#getStride();

          if (!stride) return 1;

          const styles = getComputedStyle(this.#track);
          const contentWidth = this.#track.clientWidth
            - (parseFloat(styles.paddingLeft) || 0)
            - (parseFloat(styles.paddingRight) || 0)
            + (parseFloat(styles.gap) || 0);

          return Math.max(1, Math.floor((contentWidth + 1) / stride));
        }

        #getMaxIndex() {
          return Math.max(0, this.#realSlides.length - this.#getVisibleCount());
        }

        #getCurrentIndex() {
          const stride = this.#getStride();

          if (!stride) return 0;

          return Math.round(this.#track.scrollLeft / stride) - this.#cloneCount;
        }

        #getClampedIndex() {
          return Math.max(0, Math.min(this.#getCurrentIndex(), this.#getMaxIndex()));
        }

        #scrollToIndex(index, smooth = true) {
          const stride = this.#getStride();

          this.#track.scrollTo({
            left: (index + this.#cloneCount) * stride,
            behavior: smooth ? 'smooth' : 'auto'
          });
        }

        #onScroll() {
          this.#updateControls();
          clearTimeout(this.#scrollIdleTimer);
          this.#scrollIdleTimer = setTimeout(() => this.#onScrollIdle(), 150);
        }

        #onScrollIdle() {
          if (this.#mouseDragging) return;

          this.#track.style.removeProperty('scroll-snap-type');

          if (!this.#cloneCount) return;

          const stride = this.#getStride();

          if (!stride) return;

          const realWidth = stride * this.#realSlides.length;
          const start = this.#cloneCount * stride;
          let left = this.#track.scrollLeft;

          if (left < start - stride * 0.5) left += realWidth;
          else if (left >= start + realWidth - stride * 0.5) left -= realWidth;
          else return;

          this.#track.scrollTo({
            left: Math.round(left / stride) * stride,
            behavior: 'auto'
          });
        }

        #updateControls() {
          const maxIndex = this.#getMaxIndex();
          const scrollable = this.#track.scrollWidth > this.#track.clientWidth + 1;

          this.controls?.classList.toggle('is-scrollable', scrollable);

          const index = this.#getClampedIndex();
          const loopLines = [...this.slider.querySelectorAll('[data-nh-tapm-loop-line]')];

          if (loopLines.length) {
            const progress = maxIndex > 0 ? index / maxIndex : 0;
            const activeLineIndex = Math.round(progress * (loopLines.length - 1));

            for (const [lineIndex, line] of loopLines.entries()) {
              const distance = Math.abs(lineIndex - activeLineIndex);

              line.classList.toggle('nh-tapm__loop-line--active', distance === 0);
              line.classList.toggle('nh-tapm__loop-line--near', distance === 1);
            }
          }

          if (!this.#infiniteLoop) {
            if (this.previousButton) this.previousButton.disabled = index === 0;
            if (this.nextButton) this.nextButton.disabled = index >= maxIndex;
          }

          for (const [dotIndex, dot] of [...this.dots?.children || []].entries()) {
            dot.classList.toggle('is-active', dotIndex === index);
          }
        }

        #buildDots() {
          if (!this.dots || this.#infiniteLoop) return;

          const total = this.#getMaxIndex() + 1;
          const fragment = document.createDocumentFragment();

          for (let index = 0; index < total && total > 1; index += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.dataset.nhTapmDot = index;
            dot.setAttribute('aria-label', `Slide ${index + 1}`);
            fragment.append(dot);
          }

          this.dots.replaceChildren(fragment);
        }

        #onClick(event) {
          if (this.#suppressClick) {
            event.preventDefault();
            event.stopPropagation();
            this.#suppressClick = false;
            clearTimeout(this.#clickTimer);
            return;
          }

          const control = event.target.closest('[data-nh-tapm-prev], [data-nh-tapm-next], [data-nh-tapm-dot]');

          if (!control) return;

          const baseIndex = this.#infiniteLoop ? this.#getCurrentIndex() : this.#getClampedIndex();

          if (control.hasAttribute('data-nh-tapm-prev')) this.#scrollToIndex(baseIndex - 1);
          if (control.hasAttribute('data-nh-tapm-next')) this.#scrollToIndex(baseIndex + 1);
          if (control.hasAttribute('data-nh-tapm-dot')) this.#scrollToIndex(Number(control.dataset.nhTapmDot));
        }

        #onPointerDown(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;

          this.#pointerId = event.pointerId;
          this.#dragStartX = event.clientX;
          this.#dragStartScroll = this.#track.scrollLeft;
        }

        #onPointerMove(event) {
          if (event.pointerId !== this.#pointerId || event.pointerType !== 'mouse') return;

          const distance = event.clientX - this.#dragStartX;

          if (!this.#mouseDragging && Math.abs(distance) <= 8) return;

          if (!this.#mouseDragging) {
            this.#mouseDragging = true;
            this.#track.classList.add('is-dragging');
            this.#track.style.scrollSnapType = 'none';
            this.#track.setPointerCapture?.(event.pointerId);
          }

          this.#track.scrollLeft = this.#dragStartScroll - distance;
          event.preventDefault();
        }

        #onPointerUp(event) {
          if (event.pointerId !== this.#pointerId) return;

          this.#pointerId = undefined;

          if (!this.#mouseDragging) return;

          this.#mouseDragging = false;
          this.#track.classList.remove('is-dragging');

          if (this.#track.hasPointerCapture?.(event.pointerId)) {
            this.#track.releasePointerCapture(event.pointerId);
          }

          this.#suppressClick = true;
          clearTimeout(this.#clickTimer);
          this.#clickTimer = setTimeout(() => {
            this.#suppressClick = false;
          }, 100);

          const stride = this.#getStride();

          if (stride) {
            this.#track.scrollTo({
              left: Math.round(this.#track.scrollLeft / stride) * stride,
              behavior: 'smooth'
            });
          }
        }

        #onResize() {
          clearTimeout(this.#resizeTimer);
          this.#resizeTimer = setTimeout(() => {
            const index = this.#getClampedIndex();

            this.#syncTrack();
            this.#setupSlides();
            this.#scrollToIndex(Math.min(index, this.#getMaxIndex()), false);
            this.#buildDots();
            this.#updateControls();
          }, 200);
        }
      }

      const revealSectionImages = (sectionRoot) => {
        for (const element of sectionRoot.querySelectorAll('[data-aos], image-element[data-aos]')) {
          element.classList.add('aos-init', 'aos-animate');
        }

        if (typeof AOS !== 'undefined') AOS.refresh();
      };

      const initialize = (root = document) => {
        for (const slider of root.querySelectorAll('[data-nh-tapm-slider]')) {
          const sectionId = slider.dataset.sectionId;

          if (!sectionId) continue;

          instances.get(sectionId)?.destroy();

          const instance = new nhTapmSlider(slider);

          if (instance.ready) instances.set(sectionId, instance);

          const sectionRoot = slider.closest('.nh-tapm');

          if (sectionRoot) revealSectionImages(sectionRoot);
        }
      };

      initialize();

      document.addEventListener('shopify:section:load', (event) => initialize(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        instances.get(event.detail.sectionId)?.destroy();
        instances.delete(event.detail.sectionId);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-text-and-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sliders = document.querySelectorAll('[data-nh-tap-slider]');
    sliders.forEach(function(slider) {
      var track = slider.querySelector('[data-nh-tap-track]');
      var controlsWrap = slider.querySelector('.nh-tap__controls');
      var dotsWrap = slider.querySelector('[data-nh-tap-dots]');
      var prevBtn = slider.querySelector('[data-nh-tap-prev]');
      var nextBtn = slider.querySelector('[data-nh-tap-next]');
      if (!track) return;

      var slides = track.children;
      var currentIndex = 0;
      var startX = 0;
      var currentTranslate = 0;
      var prevTranslate = 0;
      var isDragging = false;
      var animationId = null;

      function getSlideWidth() {
        if (!slides[0]) return 0;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.gap) || 12;
        return slides[0].offsetWidth + gap;
      }

      function getVisibleCount() {
        var trackW = slider.offsetWidth;
        var slideW = getSlideWidth();
        if (slideW === 0) return 1;
        return Math.round(trackW / slideW) || 1;
      }

      function getMaxIndex() {
        var visible = getVisibleCount();
        return Math.max(0, slides.length - visible);
      }

      function setPosition() {
        track.style.transform = 'translateX(' + currentTranslate + 'px)';
      }

      function goTo(index) {
        currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
        currentTranslate = -currentIndex * getSlideWidth();
        prevTranslate = currentTranslate;
        track.classList.remove('is-dragging');
        setPosition();
        updateControls();
      }

      function updateControls() {
        var maxIdx = getMaxIndex();
        if (controlsWrap) controlsWrap.classList.toggle('is-scrollable', maxIdx > 0);
        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= maxIdx;
        var dots = dotsWrap ? dotsWrap.querySelectorAll('button') : [];
        dots.forEach(function(d, i) {
          d.classList.toggle('is-active', i === currentIndex);
        });
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var total = getMaxIndex() + 1;
        if (total <= 1) return;
        for (var i = 0; i < total; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          if (i === currentIndex) dot.classList.add('is-active');
          (function(idx) {
            dot.addEventListener('click', function() { goTo(idx); });
          })(i);
          dotsWrap.appendChild(dot);
        }
      }

      function onPointerDown(e) {
        isDragging = true;
        startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        track.classList.add('is-dragging');
        if (animationId) cancelAnimationFrame(animationId);
        animationId = requestAnimationFrame(animate);
      }

      function onPointerMove(e) {
        if (!isDragging) return;
        var x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        var diff = x - startX;
        currentTranslate = prevTranslate + diff;
      }

      function onPointerUp() {
        if (!isDragging) return;
        isDragging = false;
        cancelAnimationFrame(animationId);
        var moved = currentTranslate - prevTranslate;
        var threshold = getSlideWidth() * 0.2;
        if (moved < -threshold) {
          goTo(currentIndex + 1);
        } else if (moved > threshold) {
          goTo(currentIndex - 1);
        } else {
          goTo(currentIndex);
        }
      }

      function animate() {
        setPosition();
        if (isDragging) animationId = requestAnimationFrame(animate);
      }

      track.addEventListener('pointerdown', function(e) {
        e.preventDefault();
        onPointerDown(e);
      });
      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);

      track.addEventListener('touchstart', function(e) { onPointerDown(e); }, { passive: true });
      track.addEventListener('touchmove', function(e) { onPointerMove(e); }, { passive: true });
      track.addEventListener('touchend', onPointerUp);

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          buildDots();
          goTo(currentIndex);
        }, 200);
      });

      track.querySelectorAll('a').forEach(function(link) {
        var linkStartX;
        link.addEventListener('pointerdown', function(e) { linkStartX = e.clientX; });
        link.addEventListener('click', function(e) {
          if (Math.abs(e.clientX - linkStartX) > 5) e.preventDefault();
        });
      });

      buildDots();
      goTo(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
